import React from 'react';
import { 
  Building2, 
  Users, 
  UserCheck, 
  UserX, 
  AlertCircle,
  TrendingUp,
} from 'lucide-react';
import type { OverallSummary } from '../../types/analytics';
import { StatCard } from '../../../../shared/components/cards/StatCard';

interface SummaryCardsProps {
  summary: OverallSummary | null;
  isLoading?: boolean;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({ summary, isLoading }) => {
  const absentPercent = summary && summary.totalStaff > 0 
    ? Math.round((summary.totalAbsent / summary.totalStaff) * 100) 
    : 0;
  
  const noResponsePercent = summary && summary.totalStaff > 0
    ? Math.round((summary.totalNoResponse / summary.totalStaff) * 100)
    : 0;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      <StatCard
        title="Total KVs"
        value={summary?.totalKVs || 0}
        subtitle="Schools"
        icon={<Building2 className="w-5 h-5" />}
        color="blue"
        isLoading={isLoading}
      />
      <StatCard
        title="Total Staff"
        value={summary?.totalStaff || 0}
        subtitle={`${summary?.totalRegularStaff || 0} Regular | ${summary?.totalContractualStaff || 0} Contractual`}
        icon={<Users className="w-5 h-5" />}
        color="purple"
        isLoading={isLoading}
      />
      <StatCard
        title="Present"
        value={summary?.totalPresent || 0}
        subtitle={`${summary?.overallAttendancePercent || 0}%`}
        icon={<UserCheck className="w-5 h-5" />}
        color="green"
        isLoading={isLoading}
      />
      <StatCard
        title="Absent"
        value={summary?.totalAbsent || 0}
        subtitle={`${absentPercent}%`}
        icon={<UserX className="w-5 h-5" />}
        color="red"
        isLoading={isLoading}
      />
      <StatCard
        title="No Response"
        value={summary?.totalNoResponse || 0}
        subtitle={`${noResponsePercent}%`}
        icon={<AlertCircle className="w-5 h-5" />}
        color="yellow"
        isLoading={isLoading}
      />
      <StatCard
        title="Attendance %"
        value={`${summary?.overallAttendancePercent || 0}%`}
        subtitle={`Regular: ${summary?.regularAttendancePercent || 0}% | Cont: ${summary?.contractualAttendancePercent || 0}%`}
        icon={<TrendingUp className="w-5 h-5" />}
        color="green"
        isLoading={isLoading}
      />
    </div>
  );
};

export default SummaryCards;
